import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NotifyUsersBy } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { UserService } from '../../services/api-services/user.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { DeliveryStatusComponent } from '../delivery-status/delivery-status.component';

@Component({
  selector: 'app-user-notification-popup',
  templateUrl: './user-notification-popup.component.html',
  styleUrls: ['./user-notification-popup.component.scss']
})
export class UserNotificationPopupComponent implements OnInit {
  type: any;
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  isSendToAll: boolean = false;
  disableButton: boolean;
  tenant: any = localStorage.getItem('tenant')
  payload: { NotifyUsers: boolean, NotifyUsersBy: Array<number> } = {
    NotifyUsers: false,
    NotifyUsersBy: []
  }
  constructor(
    public dialogRef: MatDialogRef<DeliveryStatusComponent>,
    private fb: FormBuilder,
    public toast: ToastrService,
    public userService: UserService,
    public formService: FormService,
    public krollService: KRollService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
  ) {
    this.disableButton = false;
    this.initializeForm();
    if (!this.props.item.RenewRefillStatusID) {
      this.isSendToAll = true;
    }
  }

  ngOnInit(): void {
    this.getCustomMessage();
  }
  onCheckChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.addNotifyControl();
    }
    else {
      this.form.removeControl('NotifyUsersBy');
    }
  }
  initializeForm() {
    let { NotifyUsers } = this.payload;
    this.form = this.fb.group({
      NotifyUsers: new FormControl(NotifyUsers, [Validators.required]),
      custom_message: new FormControl(true),
      message: new FormControl(""),
      disable: new FormControl(this.tenant == 'sl' ? true : false)
    });
  }
  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray;
  }
  private addNotifyControl() {
    this.form.addControl('NotifyUsersBy', this.fb.array([], arrayMinLengthByKey(1, 'isChecked')));
    NotifyUsersBy.forEach((x: any) => {
      this.notifyByArray.push(this.fb.group({
        id: new FormControl(x.id),
        value: new FormControl(x.value),
        isChecked: new FormControl(x.isChecked),
      }));
    });
  }
  async getStatusType() {
    let payload: any[] = [];
    Object.values(this.props['item']).forEach((element: any) => {
      try {
        if (element.RenewRefillDetailID) {
          this.type = element.StatusType;
          let data = {
            type: element.StatusType
          };
          payload.push(data);
        }
      } catch (error) {
      }
    })
    return payload

  }
  async procesMultipleCandidates() {
    let payload: any[] = [];
    Object.values(this.props['item']).forEach((element: any) => {
      try {
        if (element.RenewRefillDetailID) {
          let data = {
            RenewRefillDetailID: element.RenewRefillDetailID,
            UserID: element.UserID
          };
          payload.push(data);
        }
      } catch (error) {
      }
    })
    return payload
  }

  formSubmit() {
    if (this.form.valid) {
      this.disableButton = true;
      this.isLoading = true;
      if (this.isSendToAll) {
        this.procesMultipleCandidates().then((result: any) => {
          //******backend team required type and data in payload*******/
          let payload: any = {
            NotifyUsers: this.form.value.NotifyUsers ? result.map((a: any) => a.UserID) : [],
            NotifyUsersBy: this.form.value.NotifyUsersBy?.length > 0 ? this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id) : [],
            RenewRefillDetailID: result.map((a: any) => a.RenewRefillDetailID),
            Message: this.form.value.custom_message ? this.form.value.message : ""
          }
          if(this.tenant == 'sl'){
            delete payload.Message
          }
          this.userService.send_push_notification(payload).subscribe(res => {
            if (res.body.success) {
              this.toast.success(res.body.message);
              this.isLoading = false;
              this.dialogRef.close({ payload: payload, response: res.body });
            }
            else {
              this.disableButton = false;
              this.isLoading = false;
              this.toast.error(res.body.message);
            }
          }, err => {
            this.isLoading = false;
          });
        });
      }
      else {
        let payload = {
          NotifyUsers: this.form.value.NotifyUsers ? [this.props.item.UserID] : [],
          NotifyUsersBy: this.form.value.NotifyUsersBy?.length > 0 ? this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id) : [],
          RenewRefillDetailID: [this.props.item.RenewRefillDetailID],
          Message: this.form.value.custom_message ? this.form.value.message : ""
        }
        if(this.tenant == 'sl'){
          delete payload.Message
        }
        this.userService.send_push_notification(payload).subscribe(res => {
          if (res.body.success) {
            this.toast.success(res.body.message);
            this.isLoading = false;
            this.dialogRef.close({ payload: payload, response: res.body });
          }
          else {
            this.disableButton = false;
            this.isLoading = false;
            this.toast.error(res.body.message);
          }
        }, err => {
          this.isLoading = false;
        });
      }

    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
  getCustomMessage() {
    if (this.isSendToAll) {
      this.getStatusType().then((result: any) => {
        let payload = {
        }
        this.userService.get_checkbox_message_templates(payload).subscribe(res => {
          let result: any;
          if (res.body.success) {
            if (this.type == "renew_request") {
              result = res.body.data.renew;
            }
            else if (this.type == "refill_request") {
              result = res.body.data.refill;
            }
            else {
              result = res.body.data.autorefill;
            }
            this.form.controls.message.setValue(result.message);
          }
          else {
            this.isLoading = false;
            this.toast.error(res.body.message);
          }
        }, err => {
          this.isLoading = false;
        })
      });
    }
    else {
      this.type = this.props.item.StatusType;
      let payload = {
      }
      this.userService.get_checkbox_message_templates(payload).subscribe(res => {
        let result: any;
        if (res.body.success) {
          if (this.type == "renew_request") {
            result = res.body.data.renew;
          }
          else if (this.type == "refill_request") {
            result = res.body.data.refill;
          }
          else {
            result = res.body.data.autorefill;
          }
          this.form.controls.message.setValue(result.message);
        }
        else {
          this.isLoading = false;
          this.toast.error(res.body.message);
        }
      }, err => {
        this.isLoading = false;
      })
    }

  }

}
